import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 612 612" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path clipRule="evenodd" d="M0 71.993v108.014C0 209.818 24.2 234 54.031 234h503.937C587.786 234 612 209.824 612 180.007V71.993C612 42.182 587.8 18 557.969 18H54.031C24.214 18 0 42.176 0 71.993zM432 54h125.969C567.924 54 576 62.07 576 71.993v108.014c0 9.922-8.084 17.993-18.031 17.993H432zM36 71.993C36 62.071 44.084 54 54.031 54H396v144H54.031C44.076 198 36 189.93 36 180.007zM414 414c9.941 0 18-8.059 18-18v-90c0-9.941-8.059-18-18-18H54c-9.941 0-18 8.059-18 18v90c0 9.941 8.059 18 18 18zM72 378v-54h324v54zm270 216c9.941 0 18-8.059 18-18v-90c0-9.941-8.059-18-18-18H54c-9.941 0-18 8.059-18 18v90c0 9.941 8.059 18 18 18zm-18-36H72v-54h252zm194.272-410.272c7.029 7.029 18.427 7.029 25.456 0s7.029-18.426 0-25.456l-27-27c-7.029-7.029-18.427-7.029-25.456 0l-27 27c-7.029 7.029-7.029 18.426 0 25.456 7.029 7.029 18.427 7.029 25.456 0L504 133.456zM90 144h162.204c9.941 0 18-8.059 18-18s-8.059-18-18-18H90c-9.941 0-18 8.059-18 18s8.059 18 18 18z" fillRule="evenodd" fill={color}/>
    </svg>
)

export default class IconDropdown extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
